// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".css?ver=88a75173-afd3-4b2e-97b6-1db720fb32e1";
};